<template>
  <div class="flex justify-center">
    <div class="reports ma3">
      <h1 v-if="reportSelected" class="f6 fw4 ttu mb3 text-secondary">Отчет</h1>
      <h1 v-else class="f6 fw4 ttu mb3 text-secondary">Отчеты</h1>

      <ul v-if="!reportSelected" class="list ma0 pa0">
        <li v-for="(report, index) in $store.getters['report/reports']" :key="index">
          <a href="#" class="f5 underline dim inline-flex items-center pv2 lh-copy text-primary"
            @click="selected=index">
            <span class="pr1">{{ report.title }}</span>
          </a>
        </li>
      </ul>
      <div v-else class="selected-report">
        <a href="#" class="no-underline dim text-primary lh-copy b">
          <span>{{ reports[selected].title }}</span>
        </a>
        <button @click="selected=null" class="input-icon-button bg-light">
          <font-awesome-icon icon="times" />
        </button>
      </div>

      <p v-if="reportSelected && reports[selected].notes" class="mv2 text-secondary lh-copy" v-html="reports[selected].notes"></p>

      <!--
      <search-select
        :options="reportsNames"
        v-model="selected"
        :search-enabled="false"
        :reset-enabled="true"
        :upper-case="false"
        :show-border="false"
        :truncate="false"
        placeholder="выберите отчет"
        bg="dark"
      ></search-select>
      -->

      <div v-if="reportSelected" class="mt4">
        <!--
        <h1 class="f6 fw4 ttu mb3 text-secondary">Параметры</h1>
        -->
        <component :is="component" class="bg-white" :report="reports[selected]" @report="setActiveReport"/>
      </div>

      <div v-if="reportSelected && activeReportValid" class="mt4 flex flex-column items-end">
        <span v-if="activeReport.error" class="db report-error mb3">Что-то пошло не так. Проверьте параметры и попробуйте сформировать отчет еще раз.</span>
        <div v-if="activeReport.loading" class="flex flex-row items-center">
          <span class="db mr3 report-progress">формируем отчет...</span>
          <content-spinner/>
        </div>
        <button v-else @click="renderActiveReport" class="db button primary">
          Сформировать
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import Report from '@/components/report/Report.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'

export default {
  components: {
    Report,
    SearchSelect,
    ContentSpinner
  },
  data () {
    return {
      component: 'Report',
      selected: null
    }
  },
  watch: {
    selected (next, n, p) {
      if (next === null) {
        this.setActiveReport(null)
      }
    }
  },
  computed: {
    reportSelected () {
      return Number.isInteger(this.selected)
    },
    reports () {
      return this.$store.getters['report/reports']
    },
    reportsNames () {
      return this.reports.map(r => { return { name: r.title } })
    },
    activeReport () {
      return this.$store.getters['report/activeReport']
    },
    activeReportValid () {
      return this.activeReport?.valid
    }
  },
  methods: {
    setActiveReport (report) {
      this.$store.dispatch('report/setActiveReport', report)
    },
    renderActiveReport () {
      this.$store.dispatch('report/renderActiveReport')
    }
  }
}
</script>

<style lang="scss" scoped>
.reports {
  width: 500px;
}
.report-progress {
  color: #627D98;
}
.report-error {
  color: #E66A6A;
}
.selected-report {
  display: grid;
  grid-template-columns: 1fr 40px;
  align-items: center;
  text-align: left;
}
</style>
